import React from 'react';
import { NerdMenuElementType } from 'src/common/enums';
import NerdMenuComponent from './NerdMenuComponent';
import NerdMenuLinkListWrapper from './NerdMenuLinkListWrapper';

interface NerdMenuElementsProps {
  menuElements: NerdMenuElement[];
}

const NerdMenuElementsColumns: React.FC<{ columns: NerdMenuElement[] }> = ({ columns }) => {
  return (
    <div className="menu-columns pds-grid pds-grow pds-grid-cols-[repeat(auto-fit,210px)] pds-gap-4 md:pds-gap-4.5 lg:pds-gap-5">
      {columns.map(column => {
        const linkListWrapperElements =
          column.menuElements?.filter(
            element => element.type === NerdMenuElementType.LINK_LISTS_WRAPPER,
          ) || [];
        const componentElements =
          column.menuElements?.filter(element => element.type === NerdMenuElementType.COMPONENT) ||
          [];

        const hasComponents = componentElements.length > 0;

        return (
          <div key={column.drupal_id} className="menu-column pds-flex pds-flex-col pds-gap-4">
            {linkListWrapperElements.map(element => {
              return <NerdMenuLinkListWrapper key={element.drupal_id} linkListWrapper={element} />;
            })}

            {hasComponents ? (
              <div className="pds-space-y-4.5 pds-p-4">
                {componentElements.map(element => {
                  return <NerdMenuComponent component={element} key={element.drupal_id} />;
                })}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

const NerdMenuElements: React.FC<NerdMenuElementsProps> = function ({ menuElements }) {
  const columns = menuElements.filter(x => x.type === NerdMenuElementType.COLUMN);

  return (
    <div className="pds-container pds-flex">
      <NerdMenuElementsColumns columns={columns} />
    </div>
  );
};

export { NerdMenuElements, NerdMenuElementsColumns };
